import { render, staticRenderFns } from "./TaskFields.vue?vue&type=template&id=5b581336&"
import script from "./TaskFields.vue?vue&type=script&lang=js&"
export * from "./TaskFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b581336')) {
      api.createRecord('5b581336', component.options)
    } else {
      api.reload('5b581336', component.options)
    }
    module.hot.accept("./TaskFields.vue?vue&type=template&id=5b581336&", function () {
      api.rerender('5b581336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverableTemplates/TaskFields.vue"
export default component.exports